import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDroplet } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface HumidityProps {
    humidity: number;
    isLoaded: boolean;
}

const HumidityStats: React.FC<HumidityProps> = ({ humidity, isLoaded }) => {

    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='blue' size='2x' icon={faDroplet} />
                    <FormattedValue isLoaded={isLoaded} value={humidity} unit='%'></FormattedValue>
                </div>
            </div>
}

export default HumidityStats;
